import { render, staticRenderFns } from "./CustomerTrainingsList.vue?vue&type=template&id=9de1f92c&"
import script from "./CustomerTrainingsList.vue?vue&type=script&lang=js&"
export * from "./CustomerTrainingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports